import React from "react";
import { Card } from "react-bootstrap";
import defaultAvatar from "../../assets/images/contactus/defaultavatar.png";

export default function PersonCard({ img, name, role, phone }) {
  // If no image provided → use default avatar
  const avatarSrc = img ? img : defaultAvatar;

  return (
    <Card className="person-card">
      <Card.Body className="d-flex align-items-center gap-3 p-3">
        <div className="person-avatar-wrap d-flex align-items-center justify-content-center">
          <img
            src={avatarSrc}
            alt={name}
            className="person-avatar"
          />
        </div>

        <div className="person-info">
          <div className="person-name">{name}</div>
          {role && <div className="person-role">{role}</div>}
          {phone && (
            <a className="person-phone" href={`tel:${phone.replace(/\s+/g, "")}`}>
              {phone}
            </a>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}
